/** See `src/i18n/locales/en/reports.ts`. */
export const reports = {
  page: {
    title: 'Raporlar',
    lead: '{{company}} için mevcut verilerden oluşturulan raporlar — ayrı bir rapor verisi saklanmaz.',
    noScope: 'Raporlarını görmek için bir şirket seçin.',
    forbidden: 'Bu şirketin raporlarını görme yetkiniz yok.',
  },
  library: {
    title: 'Rapor kütüphanesi',
  },
  cards: {
    vitaliteitstrends: {
      title: 'Aylık canlılık trendleri',
      description: 'Şirket genelinde aylık toplam adım sayısı.',
    },
    deelnamerapport: {
      title: 'Katılım raporu',
      description: 'Kaç üyenin aktif olduğu ve ne kadar güncel.',
    },
    'challenge-resultaten': {
      title: 'Meydan okuma sonuçları',
      description: 'Duruma göre meydan okumalar ve katılımcıların ortalama ilerlemesi.',
    },
    communicatiebereik: {
      title: 'İletişim erişimi',
      description: 'Gönderilen, iletilen ve açılan bildirimler.',
    },
    documentgebruik: {
      title: 'Belge kullanımı',
      description: 'Yayınlanan/arşivlenen belgeler ve toplam görüntülenme sayıları.',
    },
  },
  actions: {
    exportCsv: 'CSV dışa aktar',
    exportPdf: 'PDF dışa aktar',
  },
  export: {
    pdfFallbackNote:
      'PDF dışa aktarma henüz kullanılamıyor — bunun yerine bir CSV dosyası indirildi.',
    error: 'Bu rapor dışa aktarılamadı.',
  },
} as const;
